var _path, _path2, _ellipse, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M5 7.82715H8.33333",
    stroke: "#858585",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3611 8.66016H15.1923C13.7054 8.66016 12.5 9.77944 12.5 11.1602C12.5 12.5409 13.7054 13.6602 15.1923 13.6602H17.3611C17.4306 13.6602 17.4653 13.6602 17.4946 13.6584C17.944 13.631 18.302 13.2986 18.3314 12.8813C18.3333 12.8541 18.3333 12.8219 18.3333 12.7574V9.56293C18.3333 9.49845 18.3333 9.46621 18.3314 9.43899C18.302 9.02169 17.944 8.68929 17.4946 8.66194C17.4653 8.66016 17.4306 8.66016 17.3611 8.66016Z",
    stroke: "#858585",
    strokeWidth: 1.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 15.0013,
    cy: 11.1605,
    rx: 0.833333,
    ry: 0.833333,
    fill: "#858585"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4722 8.66081C17.4074 7.10056 17.1985 6.14393 16.525 5.47045C15.5487 4.49414 13.9773 4.49414 10.8346 4.49414H8.33463C5.19194 4.49414 3.62059 4.49414 2.64428 5.47045C1.66797 6.44676 1.66797 8.01811 1.66797 11.1608C1.66797 14.3035 1.66797 15.8749 2.64428 16.8512C3.62059 17.8275 5.19194 17.8275 8.33464 17.8275H10.8346C13.9773 17.8275 15.5487 17.8275 16.525 16.8512C17.1985 16.1777 17.4074 15.2211 17.4722 13.6608",
    stroke: "#858585",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M5 4.49414L8.1129 2.43009C8.98953 1.84883 10.1771 1.84883 11.0538 2.43009L14.1667 4.49414",
    stroke: "#858585",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/WalletIcon.0fb64e6f28046052a90e5faec34c946d.svg";
export { ForwardRef as ReactComponent };